import { useEffect, useRef } from "react";

export const closeSelectInputMenu = wrapperElement => {
  const dropdownContainer = wrapperElement?.querySelector(
    '.dropdown-container[aria-expanded="true"]'
  );

  if (!dropdownContainer) {
    return;
  }

  dropdownContainer.querySelector(".dropdown-heading")?.click();
};

const useSelectInputOutsideClose = isOpen => {
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const handlePointerDown = event => {
      if (wrapperRef.current?.contains(event.target)) {
        return;
      }

      closeSelectInputMenu(wrapperRef.current);
    };

    document.addEventListener("mousedown", handlePointerDown, true);

    return () => {
      document.removeEventListener("mousedown", handlePointerDown, true);
    };
  }, [isOpen]);

  return wrapperRef;
};

export default useSelectInputOutsideClose;
